import { DrawInsideShelf } from "$src/CGS/domain/dto/article/Cabinet/Inside/DrawInsideShelf";
import { Mesh, MeshStandardMaterial } from "three";
import { EMaterialSlot } from "../../Meshes/EMaterialSlot";
import { SubMeshCollection } from "../../Meshes/SubMeshCollection";
import { InsideElementMetadata } from "../Metadata/InsideElementMetadata";
import { BaseInsideElementGenerator } from "./BaseInsideElementGenerator";
import { InsideContainerGenerator } from "./InsideContainerGenerator";
import { MeshInsideElementObject } from "../Objects/InsideElementObject";
import { LengthMaths } from "$src/CGS/domain/dto/core/Length/LengthMaths";
import { PlankGenerator } from "../PlankGenerator";

export class ShelfGenerator extends BaseInsideElementGenerator {
    constructor(insideContainerGenerator: InsideContainerGenerator, insideElementMetadata: InsideElementMetadata) {
        super(insideContainerGenerator, insideElementMetadata);
    }

    public build(): void {
        const generatedGameObject = this.createGameObject();
        const insideElementObject = new MeshInsideElementObject();

        const mesh = new Mesh();

        const subMeshCollection = new SubMeshCollection();
        subMeshCollection.merge(this.buildShelf());

        // Set the box MeshInfo
        insideElementObject.MeshInfo = subMeshCollection.createMesh(mesh);

        mesh.geometry.computeVertexNormals();

        const cabinet = this.insideContainerGenerator.cabinet;

        generatedGameObject.add(mesh);
        generatedGameObject.position.set(0, this.insideElementMetadata.Anchor.y, 0);

        cabinet.InsideElements.push(insideElementObject);
        cabinet.Placement?.add(generatedGameObject);
    }

    protected buildShelf(): SubMeshCollection {
        const topAnchor = this.insideElementMetadata.Anchor.y + LengthMaths.getLengthValue(this.insideElementMetadata.Height).meter;
        const bottomAnchor = this.insideElementMetadata.Anchor.y;

        const intersectWithGroove = this.insideContainerGenerator.cabinetShapeGenerator.verticalSplits.some(vs =>
            vs.Top > bottomAnchor && vs.Bottom < topAnchor && vs.IsGroove
        );

        const shelfOutline = this.insideContainerGenerator.buildOutline(this.insideElementMetadata, intersectWithGroove ? this.insideContainerGenerator.cabinetShapeGenerator.grooveDepth : null);

        const plankGenerator = new PlankGenerator(shelfOutline, LengthMaths.getLengthValue(this.insideElementMetadata.Height));

        const isFixed = (this.insideElementMetadata.Context as DrawInsideShelf)?.IsFixed || false;

        return plankGenerator.build(isFixed ? EMaterialSlot.Front : EMaterialSlot.Inside);
    }
}